module.exports = __webpack_public_path__ + "static/i7-018d9da2580dc176c174b34e56064c91.jpg";